import { render, staticRenderFns } from "./XDialog.vue?vue&type=template&id=6de3e3d0&scoped=true"
import script from "./XDialog.vue?vue&type=script&lang=js"
export * from "./XDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de3e3d0",
  null
  
)

export default component.exports